
import Card from '../ss-card'

import { defineComponent, getCurrentInstance } from 'vue'
import { PopInfo } from '../dist/types'

export default defineComponent({
    name: "bc-popbox",
    components: {
        Card
    },
    data () {
        return {
            list: getCurrentInstance()?.appContext
                .config.globalProperties.$bcui['bc-popbox'].popList as PopInfo[]
        }
    },
    methods: {
        removePopBox () {
            this.list.shift()
        }
    }
})
